module.exports = __webpack_public_path__ + "img/smart_watches.8b868d2d.webp";